import { Modal, Stack, Text, Button, Group } from '@mantine/core';
import { useFlowMutations } from '../hooks/useFlowMutations';
import { Flow } from '@/services/flows.api';

interface DeleteFlowModalProps {
  opened: boolean;
  onClose: () => void;
  flow: Flow | null;
}

export function DeleteFlowModal({ opened, onClose, flow }: DeleteFlowModalProps) {
  const { deleteMutation } = useFlowMutations();

  const handleDelete = async () => {
    if (!flow) return;

    try {
      await deleteMutation.mutateAsync(flow.id);
      onClose();
    } catch (error) {
      alert('Failed to delete flow. Please try again.');
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} title="Delete Flow">
      <Stack>
        <Text>
          Are you sure you want to delete <strong>{flow?.name}</strong>? This action cannot be undone.
        </Text>
        <Group justify="flex-end">
          <Button variant="subtle" onClick={onClose}>Cancel</Button>
          <Button color="red" onClick={handleDelete} loading={deleteMutation.isPending}>Delete</Button>
        </Group>
      </Stack>
    </Modal>
  );
}
